import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

const PATH = "assistants";

@Injectable({
  providedIn: 'root'
})
export class AssistantService {

  constructor(
    private APIService: ApiService
  ) { }

  public initAssistant(masterAccountID: number, accountAppId: number, integrationId: number, data: any) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${accountAppId}/integration/${integrationId}/init`, data);
  }

  public sendThreadMessage(masterAccountID: number, accountAppId: number, integrationId: number, threadId: string, message: string) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${accountAppId}/integration/${integrationId}/thread/${threadId}/message`, { message });
  }

  public reportToolCall(masterAccountID: number, accountAppId: number, integrationId: number, threadId: string, result: any) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${accountAppId}/integration/${integrationId}/thread/${threadId}/tool-call`, result);
  }

  public reportAssistantResult(masterAccountID: number, accountAppId: number, integrationId: number, threadId: string, result: any) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${accountAppId}/integration/${integrationId}/thread/${threadId}/result`, {
      result: result
    });
  }

  public generateImage(masterAccountID: number, accountAppId: number, integrationId: number, data: any) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${accountAppId}/integration/${integrationId}/generate-image`, data);
  }

}
